import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { theme } from './theme';
import Navigation from './components/Navigation';
import Footer from './components/Footer';
import Home from './pages/Home';
import Access from './pages/Access';
import Guide from './pages/Guide';
import Security from './pages/Security';
import Calendar from './pages/Calendar';
import './App.css';

function App() {
  return (
    <Router>
      <div className="app" style={{ 
        backgroundColor: theme.colors.background 
      }}>
        <Navigation />
        <div className="main-content">
          <main>
            <Routes>
              <Route path="/" element={<Home />} />
              <Route path="/access" element={<Access />} />
              <Route path="/guide" element={<Guide />} />
              <Route path="/security" element={<Security />} />
              <Route path="/calendar" element={<Calendar />} />
            </Routes>
          </main>
        </div>
        <Footer />
      </div>
    </Router>
  );
}

export default App;
